import { render, staticRenderFns } from "./OkrMonitoramento.vue?vue&type=template&id=204f0fe7&scoped=true&"
import script from "./OkrMonitoramento.vue?vue&type=script&lang=js&"
export * from "./OkrMonitoramento.vue?vue&type=script&lang=js&"
import style0 from "./OkrMonitoramento.vue?vue&type=style&index=0&id=204f0fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f0fe7",
  null
  
)

export default component.exports